export const getPlatformEmoji = (platform) => {
  switch (platform?.toLowerCase()) {
    case 'ios':
      return '🍎'; // Red apple emoji for iOS
    case 'android':
      return '🤖';
    case 'web':
      return '🌐';
    default:
      return '📱';
  }
};

export const getStatusEmoji = (status) => {
  switch (status?.toLowerCase()) {
    case 'pass':
      return '✅';
    case 'fail':
      return '❌';
    case 'skip':
      return '⏭️';
    case 'testing':
      return '🔄';
    case 'untested':
      return '⭕';
    case 'answered':
      return '✅';
    case 'not answered':
      return '❓';
    default:
      return '❓';
  }
};

export const getTestCaseStatusEmoji = (status) => {
  switch (status?.toLowerCase()) {
    case 'pass':
      return '✅';
    case 'fail':
      return '❌';
    case 'skip':
      return '⏭️';
    case 'testing':
      return '🔄';
    case 'untested':
      return '⭕';
    case 'answered':
      return '✅';
    case 'not answered':
      return '❓';
    default:
      return '❓';
  }
};

// Helper to add proper spacing after emojis for macOS
export const formatEmojiText = (emoji, text) => {
  return `${emoji}  ${text}`;
};

// Helper to format platform with emoji
export const formatPlatform = (platform) => {
  return formatEmojiText(getPlatformEmoji(platform), platform);
};

// Helper to format status with emoji
export const formatStatus = (status) => {
  return formatEmojiText(getStatusEmoji(status), status);
};

// Helper to count step results
export const countStepResults = (steps) => {
  const counts = {};
  steps.forEach(step => {
    counts[step.result] = (counts[step.result] || 0) + 1;
  });
  return counts;
};

// Helper to format result counts
export const formatResultCounts = (counts) => {
  return Object.entries(counts)
    .filter(([_, count]) => count > 0)
    .map(([status, count]) => `${getStatusEmoji(status)} ${count}`)
    .join('  ');
};

// Helper to convert image paths to proper URLs
export const getImageUrl = (imagePath, planId = null) => {
  if (!imagePath) return null;
  
  // If it's already a full URL, return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's a relative path starting with /plans/, it should work with the proxy
  if (imagePath.startsWith('/plans/')) {
    return imagePath;
  }
  
  // If it's a relative path starting with ./static/, convert to /plans/
  if (imagePath.startsWith('./static/')) {
    return imagePath.replace('./static/', '/plans/');
  }
  
  // If it's a relative path starting with static/, convert to /plans/
  if (imagePath.startsWith('static/')) {
    return imagePath.replace('static/', '/plans/');
  }
  
  // Handle backend-returned relative paths like "./images/filename.png"
  if (imagePath.startsWith('./images/') && planId) {
    const filename = imagePath.replace('./images/', '');
    return `/plans/${planId}/images/${filename}`;
  }
  
  // Handle relative paths starting with "images/" + planId
  if (imagePath.startsWith('images/') && planId) {
    const filename = imagePath.replace('images/', '');
    return `/plans/${planId}/images/${filename}`;
  }
  
  // If it's just a filename and we have a planId, construct the full path
  if (planId && !imagePath.includes('/')) {
    return `/plans/${planId}/images/${imagePath}`;
  }
  
  // If it's just a filename or other relative path without planId, assume it's an image
  // This handles cases where the path might not be properly formatted
  if (!imagePath.startsWith('/')) {
    return `/plans/${imagePath}`;
  }
  
  return imagePath;
}; 